<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2024 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<div class='d-flex flex-column pt-4 align-items-center'>
    <scrm-label labelKey='LBL_ENTER_AUTH_APP_2FA_CODE'></scrm-label>
    <input [(ngModel)]="authCode"
           id='auth_code'
           type='text'
           autocomplete='one-time-code'
           name='auth_code'
           class='mb-2 mt-2 pl-0'>

    <scrm-button id='submit-2fa-code' type='submit' [config]="submitCodeButtonConfig">
    </scrm-button>

    <div class='small mt-2 text-muted'>
        <scrm-label  labelKey='LBL_PROBLEMS_GENERATING_CODE'></scrm-label>
    </div>
    <div class='small mb-2 text-muted'>
        <scrm-label  labelKey='LBL_BACKUP_CODES_FALLBACK_INSTRUCTIONS'></scrm-label>
    </div>

</div>
